import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="translate--language-select"
export default class extends Controller {
  static targets = ["text"]

  static values = {
    language: { type: String, default: "English" },
  }

  selectLanguage(event) {
    if (!!event.params?.value) {
      this.languageValue = event.params.value
      this.translate()
      return
    }

    if (
      event.key === "Enter" ||
      (event.key === "Escape" &&
        event.target.getAttribute("aria-activedescendant"))
    ) {
      const active = document.getElementById(
        event.target.getAttribute("aria-activedescendant")
      )
      const lang = active.dataset["translate-LanguageSelectValueParam"]
      if (lang) {
        this.languageValue = lang
        this.translate()
      }
    }
  }

  translate() {
    this.dispatch("translateContent", {
      bubbles: true,
      detail: { targetLanguage: this.languageValue },
    })
  }

  show() {
    this.element.classList.remove("hidden")
  }
}
